<script lang="ts">
	import { makeComponentClassList } from "../utils";
	import RightIcon from "../SVG/RightIcon.svelte";
	import Loading from "../SVG/DefaultLoading.svelte";

	export let action = (e: HTMLElement) => {};
	export let loading = false;
	export let defaultClassname = "";
	export let rightIconVisible = true;
	export let href = "";
	export let newTab = true;

	let hover = false;

	$: classVariables = makeComponentClassList($$props);

</script>

{#if href}
	<a href={href} use:action target={newTab ? '_blank' : ""}>
		<slot hover={hover} />
		{#if rightIconVisible}
			<div class={defaultClassname + classVariables}>
				<RightIcon hover={hover} />
			</div>
		{/if}
	</a>
{:else}
	<button
		on:click
		disabled={loading}
		class:loading
		on:mouseenter={() => (hover = true)}
		on:mouseleave={() => (hover = false)}>
		{#if loading}
			<div>
				<Loading />
			</div>
		{:else}
			<slot hover={hover} />
			{#if rightIconVisible}
				<div>
					<RightIcon hover={hover} />
				</div>
			{/if}
		{/if}
	</button>
{/if}

<style lang="scss">
	button,
	a {
		display: flex;
		gap: 10.5px;
		justify-content: space-between;
		align-items: center;
		background-color: transparent;
		border: none;
		box-sizing: border-box;
		border-bottom: 1px solid #416bcf;
		padding: 0;
		padding-bottom: 2px;
		transition: all 0.5s;

		&.loading {
			border-bottom: none;
			&:hover {
				cursor: progress;
				border-bottom: none;
			}
		}

		&:hover {
			cursor: pointer;
			border-bottom: 1px solid #416bcf;
		}

		div {
			width: 15.8px;
			height: 14px;
		}
	}

</style>
